import type redesignEn from "./redesign.en";

const redesignAr: Record<keyof typeof redesignEn, string> = {
  "nav.module.commerce": "التجارة",
  "nav.module.people": "الأشخاص",
  "nav.module.growth": "النمو",
  "nav.module.storefront": "واجهة المتجر",
  "nav.module.insights": "الرؤى",
  "nav.module.finance": "المالية",
  "nav.catalog": "الكتالوج",
  "nav.stock_levels": "مستويات المخزون",
  "nav.stock_counts": "جرد المخزون",
  "nav.themes": "السمات",
  "nav.features": "الميزات",
  "nav.returns": "المرتجعات",
  "nav.reviews": "التقييمات",
  "nav.help": "المساعدة",
  "nav.collapse": "طي الشريط الجانبي",
  "nav.expand": "توسيع الشريط الجانبي",
  "nav.breadcrumb": "مسار التنقل",

  "settings.landing_hint": "أدر طريقة عمل متجرك، من المدفوعات والشحن إلى فريقك.",
  "settings.group.business": "النشاط التجاري",
  "settings.group.business_hint": "ملف المتجر وحالته وسياساته",
  "settings.group.selling": "البيع",
  "settings.group.selling_hint": "المدفوعات والدفع والشحن والضرائب",
  "settings.group.operations": "العمليات",
  "settings.group.operations_hint": "المستودعات والمخزون والإشعارات والحقول المخصصة",
  "settings.group.privacy": "العملاء والخصوصية",
  "settings.group.privacy_hint": "حسابات العملاء وطلبات البيانات",
  "settings.group.account": "الحساب",
  "settings.group.account_hint": "الفريق والاشتراك والنطاقات والنشاط",

  "palette.group.pages": "الصفحات",
  "palette.group.settings": "الإعدادات",
  "palette.group.actions": "إجراءات سريعة",
  "palette.action.product": "إنشاء منتج",
  "palette.action.order": "إنشاء طلب يدوي",
  "palette.action.customer": "إضافة عميل",
  "palette.action.collection": "إنشاء مجموعة",
  "palette.action.discount": "إنشاء خصم",
  "palette.action.page": "إضافة صفحة",
  "palette.action.post": "كتابة مقال",
};

export default redesignAr;
